import { render } from "./inventoryreport.vue?vue&type=template&id=471a91fa"
import script from "./inventoryreport.vue?vue&type=script&lang=js"
export * from "./inventoryreport.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-MakProd\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__